import { conditionModal } from './conditionModal'
import { updateNodeConnections } from '../../functions/utils'

// eslint-disable-next-line
export default async (node, editor) => {
  const oldData = node.data
  const { value: conditionData } = await conditionModal(oldData, node)

  if (conditionData && Object.values(conditionData).length > 0) {
    Object.assign(node.data, conditionData)
    node.update()
    updateNodeConnections(node)
  }

  return false
}